export const isDeviceMobile = () => {
  if (window.innerWidth < 768) {
    return true;
  }
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent || '',
  );
};

export const generateImagePath = (image: string) => `/media/images/${image}`;
export const generateSVGPath = (svg: string) => svg;
